import { Badge } from '@bbpos/ui';

export interface SupplierStatusBadgeProps {
  isActive: boolean;
  size?: 'sm' | 'md';
}

export function SupplierStatusBadge({ isActive, size = 'sm' }: SupplierStatusBadgeProps) {
  return (
    <Badge variant={isActive ? 'success' : 'draft'} size={size}>
      <span className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {isActive ? 'Active' : 'Inactive'}
      </span>
    </Badge>
  );
}
